<template>
  <div
    ref="previewRef"
    class="lt-md-preview-container lt-md-view"
    @click="onPreviewClick"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { mdRenderProps } from '../editor-md-types'
import {
  useEditorMdRender,
  useMdRenderWatcher,
} from '../composables/use-editor-md-render'

defineOptions({ name: 'LtRenderMd' })
const props = defineProps(mdRenderProps)

const emits = defineEmits(['mdRenderChange', 'checkedChange'])

const { previewRef, renderService, onPreviewClick, setContainerContent } =
  useEditorMdRender(props, emits)
useMdRenderWatcher(props, renderService, setContainerContent)
</script>
